import React from 'react'
import { Button, Intent } from "@blueprintjs/core";
import InterludePagination from "components/Player/InProgressSession/InterludePagination";
import { translate } from 'utlis/translations/i18n';

const InterludeController = ({ isFirstInterlude, isLastInterlude, session, instance, onNextInterlude, onPrevInterlude, onFinishInterlude }) => {
    return (
        <div className="interlude-control-wrapper">
            <div className="navigation">
                <div>
                    {!isFirstInterlude() && (
                        <Button
                            text={translate('previous')}
                            intent={Intent.PRIMARY}
                            icon="chevron-left"
                            disabled={isFirstInterlude()}
                            onClick={onPrevInterlude}
                        />
                    )}
                </div>
                <InterludePagination
                    session={session}
                    sessionInstance={instance}
                />
                <div>
                    {isLastInterlude() && (
                        <Button
                            text={translate('start')}
                            rightIcon="tick"
                            intent={Intent.SUCCESS}
                            disabled={!isLastInterlude()}
                            onClick={onFinishInterlude}
                        />
                    )}
                    {!isLastInterlude() && (
                        <Button
                            text={translate('next')}
                            intent={Intent.PRIMARY}
                            rightIcon="chevron-right"
                            disabled={isLastInterlude()}
                            onClick={onNextInterlude}
                        />
                    )}
                </div>
            </div>
        </div>

    )
}

export default InterludeController
